// extracted by mini-css-extract-plugin
export default {"item":"TablePropertiesItem_item__1ybHP","link":"TablePropertiesItem_link__xrHeh"};